import * as React from 'react';

import Button from '../../ui/Buttons/Button';
import {Alerts} from '../../ui/Alerts/Alerts';
import {ContentModal} from '../../ui/modals/ContentModal/ContentModal';
import {EmptyState} from '../../ui/EmptyState/EmptyState';
import {OrderableItem} from '../item.class';
import {User} from '../../users/user.class';
import {ItemSpinner} from '../item-spinner/ItemSpinner';

interface AlternateProductsModalProps {
    alternateProducts: OrderableItem[];
    canEdit: boolean;
    categoryPath?: string;
    errorMessage?: string | JSX.Element;
    onHide: () => void;
    onSelectAlternate?: (itemNum: string) => void;
    ownerType?: `list` | `My Shop`;
    show: boolean;
    showAddToOrder?: boolean;
    user: User;
}

export const AlternateProductsModal = ({
    alternateProducts,
    canEdit,
    categoryPath,
    errorMessage,
    onHide,
    onSelectAlternate,
    ownerType,
    show,
    showAddToOrder,
    user,
}: AlternateProductsModalProps) => {
    const componentName = `AlternateProductsModal`;

    /**
     * Template
     */
    return (
        <>
            <ContentModal
                e2eLabel="AlternateProductsModal"
                onClose={onHide}
                show={show}
                title={<div className="tw-text-[1.75rem] tw-font-normal tw-leading-[1.2] tw-mb-0">Alternate Products</div>}
            >
                <>
                    <Alerts
                        message={errorMessage}
                        variant="danger"
                    />
                    {!canEdit && !showAddToOrder && (
                        <Alerts
                            message={`Please contact${ownerType ? ' ' + ownerType : ''} owner to replace discontinued item`}
                            variant="warning"
                        />
                    )}
                    {!alternateProducts?.length && (
                        <EmptyState
                            message={
                                <div className="tw-items-center tw-flex tw-flex-col">
                                    <div className="tw-mb-4">No alternate products are currently available.</div>
                                    {categoryPath && (
                                        <Button
                                            className="tw-w-[150px]"
                                            onClick={() => location.assign(`/browse/${categoryPath}`)}
                                            size="sm"
                                            variant="secondary"
                                        >
                                            Shop Category
                                        </Button>
                                    )}
                                </div>
                            }
                        />
                    )}
                    {alternateProducts?.length > 0 && (
                        <>
                            <div className="tw-overflow-auto"
                            data-e2e="alternate-products-component">
                                <ItemSpinner
                                    altProducts={true}
                                    canEdit={canEdit}
                                    componentName={componentName}
                                    gaItemListName="AlternateProductsModal"
                                    loaded={true}
                                    maxSlides={3}
                                    onSelectAlternate={onSelectAlternate}
                                    orderableItems={alternateProducts}
                                    showAddToOrder={showAddToOrder}
                                    user={user}
                                />
                            </div>
                            <div className="tw-py-4">
                                Alternate products may not be identical in style or function to original selection.
                            </div>
                        </>
                    )}
                </>
            </ContentModal>
        </>
    );
};
